//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.Tables.js";
import "../Diagramming/Diagramming.BaseTaggedObjectBuilder.js";
import "../no/Diagramming.js";
let d=[[[0,"CanHide",1,0],[0,"Hidden",1,0],[0,"Size",1,0],[0,"SizingMethod",1,0]],[[["inheritOption","elementToInheritFrom"],"Inherit",{},2,0]],[]];
SPLM.Diagramming.Tables.CellRangeBuilder = class extends SPLM.Diagramming.BaseTaggedObjectBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Diagramming.Tables.CellRangeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Diagramming.Tables.CellRangeBuilder.InheritOption = Object.freeze({
    "Preferences" : "Preferences", "CustomerDefaults" : "CustomerDefaults", "Selection" : "Selection"});

export default SPLM;